export const TypeUtils = {
    nameof: <T>(name: keyof T) => name
}